import React, { useState, useEffect } from "react";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";
import { Checkbox } from "../../../components/ui/Checkbox";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/AppIcon";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const ShippingForm = ({
  onFormChange,
  savedAddresses = [],
  isAuthenticated = false,
}) => {
  const { t } = useTranslation();

  const { provinces, countries } = useSelector(
    (province_id) => province_id.general
  );

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
   // email: "",
    phone: "",
    address: "",
    province_id: "",
    /*   saveAddress: false,
    useExistingAddress: false,
    selectedAddressId: "",*/
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (onFormChange) {
      onFormChange(formData, Object.keys(errors).length === 0);
    }
  }, [formData, errors, onFormChange]);

  const validateField = (name, value) => {
    const newErrors = { ...errors };

    switch (name) {
      case "first_name":
        if (!value.trim()) {
          newErrors.first_name = t("first_nameRequired");
        } else if (value.length < 2) {
          newErrors.first_name = t("first_nameMinLength");
        } else {
          delete newErrors.first_name;
        }
        break;

      case "last_name":
        if (!value.trim()) {
          newErrors.last_name = t("last_nameRequired");
        } else if (value.length < 2) {
          newErrors.last_name = t("last_nameMinLength");
        } else {
          delete newErrors.last_name;
        }
        break;


      case "phone":
        const phoneRegex = /^\+?[\d\s\-\(\)]{10,}$/;
        if (!value.trim()) {
          newErrors.phone = t("phoneRequired");
        } else if (!phoneRegex.test(value)) {
          newErrors.phone = t("phoneInvalid");
        } else {
          delete newErrors.phone;
        }
        break;

      case "address":
        if (!value.trim()) {
          newErrors.address = t("addressRequired");
        } else if (value.length < 5) {
          newErrors.address = t("addressMinLength");
        } else {
          delete newErrors.address;
        }
        break;

      case "city":
        if (!value.trim()) {
          newErrors.city = t("cityRequired");
        } else if (value.length < 2) {
          newErrors.city = t("cityMinLength");
        } else {
          delete newErrors.city;
        }
        break;

      case "province_id":
        if (!value) {
          newErrors.province_id = t("province_idRequired");
        } else {
          delete newErrors.province_id;
        }
        break;

      case "zipCode":
        const zipRegex = /^\d{5}(-\d{4})?$/;
        if (!value.trim()) {
          newErrors.zipCode = t("zipCodeRequired");
        } else if (!zipRegex.test(value)) {
          newErrors.zipCode = t("zipCodeInvalid");
        } else {
          delete newErrors.zipCode;
        }
        break;

      default:
        break;
    }

    setErrors(newErrors);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    if (type !== "checkbox") {
      validateField(name, newValue);
    }
  };

  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    validateField(name, value);
  };

  const handleExistingAddressChange = (addressId) => {
    const selectedAddress = savedAddresses.find(
      (addr) => addr.id === addressId
    );

    if (selectedAddress) {
      setFormData((prev) => ({
        ...prev,
        selectedAddressId: addressId,
        first_name: selectedAddress.first_name,
        last_name: selectedAddress.last_name,
        address: selectedAddress.address,
        city: selectedAddress.city,
        province_id: selectedAddress.province_id,
        zipCode: selectedAddress.zipCode,
        country: selectedAddress.country,
        phone: selectedAddress.phone || prev.phone,
        useExistingAddress: true,
      }));
      setErrors({});
    }
  };

  const handleNewAddressToggle = () => {
    setFormData((prev) => ({
      ...prev,
      useExistingAddress: false,
      selectedAddressId: "",
      first_name: "",
      last_name: "",
      address: "",
      city: "",
      province_id: "",
      zipCode: "",
      country: "US",
    }));
    setErrors({});
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-2">
        <Icon name="Truck" size={20} className="text-primary" />
        <h2 className="text-xl font-semibold text-text-primary">
          {t("shippingInformation")}
        </h2>
      </div>

      {/* Existing Addresses for Authenticated Users */}
      {/*isAuthenticated && savedAddresses.length > 0 && (
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <Checkbox
              name="useExistingAddress"
              checked={formData.useExistingAddress}
              onChange={handleInputChange}
              label={t("useSavedAddress")}
            />
          </div>

          {formData.useExistingAddress && (
            <div className="space-y-3">
              <Select
                // label={t("selectSavedAddress")}
                options={savedAddresses.map((addr) => ({
                  value: addr.id,
                  label: `${addr.first_name} ${addr.last_name} - ${addr.address}, ${addr.city}, ${addr.province_id} ${addr.zipCode}`,
                }))}
                value={formData.selectedAddressId}
                onChange={(value) => handleExistingAddressChange(value)}
                //   placeholder={t("chooseAddress")}
              />

              <Button
                variant="outline"
                size="sm"
                onClick={handleNewAddressToggle}
                iconName="Plus"
                iconPosition="left"
              >
                {t("useNewAddress")}
              </Button>
            </div>
          )}
        </div>
      )*/}

      {/* Shipping Form */}
      {(!formData.useExistingAddress || !isAuthenticated) && (
        <div className="space-y-4 text-right">
          {/* Name Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label={t("firstName")}
              name="first_name"
              type="text"
              value={formData.first_name}
              onChange={handleInputChange}
              error={errors.first_name}
              required
              //  placeholder={t("enterFirstName")}
            />

            <Input
              label={t("lastName")}
              name="last_name"
              type="text"
              value={formData.last_name}
              onChange={handleInputChange}
              error={errors.last_name}
              required
              //    placeholder={t("enterLastName")}
            />
          </div>

          {/* Contact Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
           {/* <Input
              label={t("emailAddress")}
              name="email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              error={errors.email}
              required
              //  placeholder={t("yourEmail")}
              description={t("orderUpdates")}
            />*/}

            <Input
              label={t("phoneNumber")}
              name="phone"
              type="tel"
              value={formData.phone}
              onChange={handleInputChange}
              error={errors.phone}
              required
              // placeholder={t("phonePlaceholder")}
              description={t("deliveryCoordination")}
            />
          </div>

          {/* Address */}
          <Input
            label={t("streetAddress")}
            name="address"
            type="text"
            value={formData.address}
            onChange={handleInputChange}
            error={errors.address}
            required
            //  placeholder={t("addressPlaceholder")}
          />
                <div>
            <select
              name="province"
           value={formData.province}
              onChange={handleInputChange}
              className={`block w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 ease-in-out hover:border-blue-400 ${
                errors.province_id ? "border-red-500" : ""
              }`}
              required
              error={errors.province}
            >
              <option value="" disabled>
                {t("selectProvince")}
              </option>
              {provinces.map((province) => (
                <option key={province.id} value={province.id}>
                  {province.name}
                </option>
              ))}
            </select>
          </div>



          {/* Save Address Option for Authenticated Users
          {isAuthenticated && (
            <div className="pt-4 border-t border-border">
              <Checkbox
                name="saveAddress"
                checked={formData.saveAddress}
                onChange={handleInputChange}
                label={t("saveAddress")}
                description={t("secureStoreAddress")}
              />
            </div>
          )} */}
        </div>
      )}

      {/* Security Notice */}
      <div className="bg-muted/30 rounded-lg p-4 text-right">
        <div className="flex items-start space-x-3">
          <Icon name="Shield" size={20} className="text-success mt-0.5" />
          <div>
            <h4 className="font-medium text-text-primary mb-1">
              {t("secureCheckout")}
            </h4>
            <p className="text-sm text-text-secondary">{t("secureInfo")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingForm;
